<template>
  <button
    v-if="
      Object.keys(priceTableStore.priceRows).length >
      Object.keys(priceTableStore.limitedPriceRows).length
    "
    type="button"
    class="mt-3 flex items-center gap-1 text-sm underline"
    @click="priceTableStore.showMore = !priceTableStore.showMore"
  >
    <FontAwesomeIcon
      :icon="{
        prefix: 'fas',
        iconName: priceTableStore.showMore ? 'chevron-up' : 'chevron-down',
      }"
    />
    <span v-if="!priceTableStore.showMore">
      {{ $t('general.price_table.filters.show_more') }}
    </span>
    <span v-else>
      {{ $t('general.price_table.filters.show_less') }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { usePriceTableStore } from '@/stores/PriceTable/PriceTableStore.ts';

const priceTableStore = usePriceTableStore();
</script>
